import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Package } from 'lucide-react';
import ContactModal from './ContactModal';

const Hero = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <section className="relative bg-gradient-to-br from-blue-600 via-blue-700 to-blue-900 text-white overflow-hidden min-h-[600px]">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="/images/photo-1644079446600-219068676743.jpg"
          alt="Modern warehouse"
          className="w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-blue-700/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <Package className="h-4 w-4" />
            <span className="text-sm font-medium">2000 m² modernaus sandėlio</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
            Profesionalūs logistikos sprendimai Jūsų verslui
          </h1>

          {/* Subheading */}
          <p className="text-lg md:text-xl text-blue-100 mb-6">
            Efektyvus sandėliavimas, krovos darbai ir tiekimo grandinės valdymas Kaune.
            Mes perimame logistikos procesus, kad Jūs galėtumėte susitelkti į savo verslo augimą.
          </p>

          {/* Mission Statement */}
          <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-4 mb-6">
            <p className="text-base text-blue-50 italic">
              Mūsų tikslas – glaudus bendradarbiavimas, lanksti reakcija į Jūsų poreikius
              ir reali, pamatuojama nauda Jūsų verslui.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={() => setIsModalOpen(true)}
              className="inline-flex items-center justify-center bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-blue-50 transition-all shadow-xl hover:shadow-2xl hover:scale-105 group"
              data-testid="hero-cta-contact"
            >
              Gauti pasiūlymą
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>
            <Link
              to="/paslaugos"
              className="inline-flex items-center justify-center bg-transparent border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-all"
              data-testid="hero-cta-services"
            >
              Peržiūrėti paslaugas
            </Link>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Wave */}
      <div
        className="absolute bottom-0 left-0 right-0 z-10 pointer-events-none select-none"
        style={{ transform: 'scaleY(-1)' }}
      >
        <svg
          className="w-full h-14 md:h-20 fill-current text-gray-50 translate-y-0"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
        </svg>
      </div>

      {/* Contact Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default Hero;
